declare namespace $ {

	export class $mol_icon_filter extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=filter.view.tree.d.ts.map